import { inject, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' }) 
export class DomSanitizerService {
  private sanitizer = inject(DomSanitizer);

    // This method is specifically designed for situations where you absolutely know
    // the URL is safe and has been properly validated and sanitized before calling this method.
    // It tells Angular to bypass its default security checks and trust the provided string as a safe URL. 
    // This is a potential security risk, so use this method with caution.
    bypassSecurityTrustHtml(html: string) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    sanitizeInput(userInput: string, context: SecurityContext) {
        return this.sanitizer.sanitize(context, userInput);
  }
}